import React, { useState } from "react";
import { Button, Icon, Confirm } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { VirtualScenes } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { MultiStepForm } from "../SceneForm";
import "./SceneItems.scss";

const virtualSceneController = new VirtualScenes();

export function SceneItems(props) {
  const { scene, onReload } = props;
  const [showModal, setShowModal] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false); // New state to track update mode
  const [showConfirm, setShowConfirm] = useState(false);
  const { accessToken } = useAuth();

  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateScene = () => {
    setIsUpdateMode(true); // Set update mode true
    setShowModal(true); // Open modal
  };

  const onDelete = async () => {
    try {
      await virtualSceneController.deleteVirtualScene(accessToken, scene.refId);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error("Error al eliminar la escena:", error);
    }
  };

  function formatCategories(categories) {
    // Unimos los valores del array con un espacio entre ellos
    return categories.join(" ");
  }

  return (
    <>
      <div className="scene-item">
        <div className="scene-item__image">
          <img
            src={scene.bannertopUrl}
            alt={scene.title}
            loading="lazy"
            className="scene-item__image"
          />
        </div>
        <div className="scene-item__content">
          <h2>{scene.title}</h2>
          <p>{formatCategories(scene.category)}</p>
          <p>{formatCategories(scene.subcategory)}</p>
          <div className="scene-item__buttons">
            <Button icon as="a" href={scene.urlsala} target="_blank">
              <Icon name="eye" />
            </Button>
            <Button icon primary onClick={openUpdateScene}>
              <Icon name="pencil" />
            </Button>
            <Button icon color="red" onClick={() => setShowConfirm(true)}>
              <Icon name="trash" />
            </Button>
          </div>
        </div>
      </div>

      <BasicModal
        show={showModal}
        close={() => setShowModal(false)}
        title={
          <>
            Editando {scene.title}
            <br />
            {scene.account}
          </>
        }
      >
        <MultiStepForm
          scene={scene}
          onClose={() => setShowModal(false)}
          onReload={onReload}
          isUpdateMode={isUpdateMode}
        />
      </BasicModal>
      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={`Eliminar la Sala ${scene.title}`}
        size="mini"
      />
    </>
  );
}
